import styled from 'styled-components'

export const TabContentHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
`

export const TabHeaderRightBlock = styled.div`
  display: flex;
  align-items: center;
  column-gap: 16px;
`
